import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext({ theme: 'dark', setTheme: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('msml-theme') || 'dark';
  });

  useEffect(() => {
    localStorage.setItem('msml-theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
    // Also mirror to className so consumers and tests that inspect
    // document.documentElement.className see the theme transition.
    const html = document.documentElement;
    html.classList.remove('theme-dark', 'theme-light');
    html.classList.add(`theme-${theme}`);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
